// @flow

export const bindMethods = function(klass: any, ...methodNames: string[]) {
  methodNames.forEach(methodName => {
    klass[methodName] = klass[methodName].bind(klass);
  });
};
